/**
 * Campaign PDP gallery — avoids Owl Hash plugin (use data-media-id, not data-hash).
 */
(function () {
  var MOBILE_MQ = '(max-width: 749px)';
  var DESKTOP_SLIDE_MQ = '(min-width: 990px)';
  var MEDIA_ID_RE = /^media-(?:mobile-live|\d+)$/i;

  function CampaignPdpGallery(root) {
    this.root = root;
    this.carousel = root.querySelector('.product-carousel');
    this.$carousel = null;
    this._detachedSlides = {};
    this.initialized = false;
    this.navigating = false;
    this.lastRelativeIndex = 0;
    this.desktopSlideMq = window.matchMedia(DESKTOP_SLIDE_MQ);
  }

  CampaignPdpGallery.prototype.getOwlCore = function () {
    return this.$carousel && this.$carousel.data('owl.carousel');
  };

  CampaignPdpGallery.prototype.getRelativeIndex = function () {
    var core = this.getOwlCore();
    if (!core) return 0;
    return core.relative(core.current());
  };

  CampaignPdpGallery.prototype.isMobile = function () {
    return window.matchMedia(MOBILE_MQ).matches;
  };

  CampaignPdpGallery.prototype.isDesktop = function () {
    return this.desktopSlideMq.matches;
  };

  // Breakpoint-specific first slides. Each entry is detached from the carousel
  // on the breakpoint where it must not show, and re-inserted (as the first
  // slide) on the breakpoint where it belongs. "desktop" = shown at >=990px,
  // "mobile" = shown at <=749px. Order matters: the entry that should end up
  // first on a given breakpoint is inserted last (insertBefore firstChild).
  CampaignPdpGallery.BREAKPOINT_SLIDES = [
    { selector: '.campaign-pdp-hero__carousel-slide--mobile-only', show: 'mobile' },
    { selector: '.campaign-pdp-hero__carousel-slide--mobile-hero-only', show: 'mobile' },
    { selector: '.campaign-pdp-hero__carousel-slide--desktop-only', show: 'desktop' },
  ];

  // Detach the slides that must not appear at the current breakpoint, and
  // re-insert (as the first carousel children) the ones that should. Must run
  // when slides are DIRECT children of the carousel — i.e. AFTER destroyOwl()
  // has unwrapped Owl's .owl-item nodes, never while Owl is live.
  CampaignPdpGallery.prototype.prepareSlides = function () {
    if (!this.carousel) return;
    var self = this;
    var isDesktop = this.isDesktop();

    if (!this._detachedSlides) this._detachedSlides = {};

    // Insert "shown" slides last so the intended one ends up first. Process the
    // array in order; for shown slides we insertBefore(firstChild), so the last
    // inserted wins the first position.
    CampaignPdpGallery.BREAKPOINT_SLIDES.forEach(function (cfg) {
      var shouldShow = cfg.show === 'desktop' ? isDesktop : !isDesktop;
      // The node may currently be: in the carousel, or held detached. Find it.
      var inDom = self.carousel.querySelector(cfg.selector);
      var held = self._detachedSlides[cfg.selector] || null;
      var node = inDom || held;
      if (!node) return; // this slide doesn't exist in this section

      if (shouldShow) {
        if (!inDom) {
          self.carousel.insertBefore(node, self.carousel.firstChild);
          self._detachedSlides[cfg.selector] = null;
        }
      } else {
        if (inDom) {
          self._detachedSlides[cfg.selector] = inDom;
          inDom.remove();
        }
      }
    });
  };

  CampaignPdpGallery.prototype.getActiveMediaId = function () {
    if (!this.$carousel) return '';

    var $el = this.$carousel.find('.owl-item.active [data-media-id]').first();
    if (!$el.length) {
      $el = this.$carousel.find('.owl-item:not(.cloned) [data-media-id]').first();
    }
    return $el.attr('data-media-id') || '';
  };

  CampaignPdpGallery.prototype.getSlideIndex = function (slideRef) {
    if (!this.carousel) return 0;

    var target =
      slideRef === 'mobile-live'
        ? this.carousel.querySelector('.campaign-pdp-hero__carousel-slide--mobile-only')
        : this.carousel.querySelector('[data-dx-slide="' + slideRef + '"]');

    if (!target) {
      var numeric = parseInt(slideRef, 10);
      return isNaN(numeric) ? 0 : numeric;
    }

    if (typeof jQuery !== 'undefined' && this.$carousel) {
      var $item = jQuery(target).closest('.owl-item');
      if ($item.length) {
        var owlIndex = this.$carousel
          .find('.owl-stage > .owl-item:not(.cloned)')
          .index($item);
        if (owlIndex >= 0) return owlIndex;
      }
    }

    var slides = this.carousel.querySelectorAll('[data-dx-slide]');
    for (var i = 0; i < slides.length; i++) {
      if (slides[i] === target) return i;
    }
    return 0;
  };

  CampaignPdpGallery.prototype.goTo = function (slideRef) {
    if (!this.$carousel || !this.$carousel.data('owl.carousel') || this.navigating) {
      return;
    }

    this.navigating = true;
    var index = this.getSlideIndex(String(slideRef));
    var self = this;

    this.$carousel.trigger('to.owl.carousel', [index, 250, true]);

    window.setTimeout(function () {
      self.navigating = false;
      self.lastRelativeIndex = self.getRelativeIndex();
    }, 300);
  };

  CampaignPdpGallery.prototype.updateActiveThumbnail = function (mediaId) {
    var id = mediaId || this.getActiveMediaId();
    var thumbnails = this.root.querySelectorAll('.thumbnail-link');
    if (thumbnails.length === 0) return;

    thumbnails.forEach(function (thumb) {
      thumb.classList.remove('active');
    });

    if (!id) {
      thumbnails[0].classList.add('active');
      return;
    }

    var activeThumb = Array.from(thumbnails).find(function (thumb) {
      return thumb.getAttribute('data-media-id') === id;
    });
    if (!activeThumb) return;

    activeThumb.classList.add('active');
    var container = activeThumb.closest('.product-thumbnails-nav');
    if (!container) return;

    var thumbLeft = this.getThumbScrollLeft(container, activeThumb);
    var thumbRight = thumbLeft + activeThumb.offsetWidth;
    var viewLeft = container.scrollLeft;
    var viewRight = viewLeft + container.clientWidth;

    if (thumbLeft < viewLeft - 1 || thumbRight > viewRight + 1) {
      container.scrollTo({
        left: thumbLeft,
        behavior: this.isMobile() ? 'auto' : 'smooth',
      });
    }
  };

  CampaignPdpGallery.prototype.onSlideChanged = function () {
    if (this.navigating) return;
    this.lastRelativeIndex = this.getRelativeIndex();
    this.updateActiveThumbnail(this.getActiveMediaId());
  };

  /** Block Owl loop-style jumps (e.g. first slide → last on overswipe). */
  CampaignPdpGallery.prototype.clampLoopWrap = function () {
    var core = this.getOwlCore();
    if (!core || core.settings.loop || this.navigating) return false;

    var count = core.items().length;
    if (count <= 1) return false;

    var rel = core.relative(core.current());
    var prev = this.lastRelativeIndex;
    var wrapped =
      (prev === 0 && rel === count - 1) ||
      (prev === count - 1 && rel === 0) ||
      Math.abs(rel - prev) > 1;

    if (!wrapped) {
      this.lastRelativeIndex = rel;
      return false;
    }

    var self = this;
    this.navigating = true;
    core.to(prev, 200, true);
    window.setTimeout(function () {
      self.navigating = false;
      self.lastRelativeIndex = self.getRelativeIndex();
    }, 250);
    return true;
  };

  CampaignPdpGallery.prototype.getOwlOptions = function () {
    return {
      items: 1,
      loop: false,
      rewind: false,
      center: false,
      slideBy: 1,
      freeDrag: false,
      autoplay: false,
      margin: 0,
      nav: false,
      dots: true,
      smartSpeed: 250,
      dragEndSpeed: 250,
      mouseDrag: true,
      touchDrag: true,
      pullDrag: false,
      URLhashListener: false,
      startPosition: 0,
    };
  };

  CampaignPdpGallery.prototype.destroyOwl = function () {
    if (!this.$carousel) return;
    this.$carousel.off('.campaignPdp');
    if (this.$carousel.data('owl.carousel')) {
      this.$carousel.trigger('destroy.owl.carousel');
    }
    this.$carousel.removeClass('owl-loaded owl-drag');
    this.lastRelativeIndex = 0;
  };

  CampaignPdpGallery.prototype.initOwl = function (callback) {
    var self = this;

    if (typeof jQuery === 'undefined' || !jQuery.fn.owlCarousel) {
      window.setTimeout(function () {
        self.initOwl(callback);
      }, 100);
      return;
    }

    if (!this.carousel) {
      if (callback) callback();
      return;
    }

    // destroyOwl first so Owl unwraps its .owl-item nodes and our breakpoint
    // slides are direct children again; only then is it safe to detach/reattach.
    this.destroyOwl();
    this.prepareSlides();
    this.$carousel = jQuery(this.carousel);
    this.$carousel.owlCarousel(this.getOwlOptions());

    var core = this.getOwlCore();
    if (core) {
      core.settings.loop = false;
      core.settings.rewind = false;
      if (this.$carousel.find('.owl-item.cloned').length) {
        this.$carousel.find('.owl-item.cloned').remove();
        core.invalidate('items');
        core.update();
      }
    }

    this.lastRelativeIndex = this.getRelativeIndex();

    this.$carousel.on('changed.owl.carousel.campaignPdp', function () {
      window.requestAnimationFrame(function () {
        if (self.clampLoopWrap()) return;
        self.onSlideChanged();
        self.syncThumbArrows();
      });
    });

    this.$carousel.on('click.owl.carousel.campaignPdp', '.owl-dot', function () {
      window.setTimeout(function () {
        self.onSlideChanged();
      }, 300);
    });

    window.requestAnimationFrame(function () {
      self.refreshOwlHeight();
    });

    this.disableImageDrag();

    window.setTimeout(function () {
      self.onSlideChanged();
      self.syncThumbArrows();
      self.bindMainImageLoad();
      if (callback) callback();
    }, 100);
  };

  // Prevent native image drag from hijacking Owl's mouse-drag (slide otherwise
  // "glues" to the cursor). CSS user-drag handles WebKit; this covers the rest
  // (Firefox ignores user-drag) by killing draggable + the dragstart event.
  CampaignPdpGallery.prototype.disableImageDrag = function () {
    var images = this.root.querySelectorAll(
      '.dx-main-image-frame img, .thumbnail-image, .owl-item img'
    );
    images.forEach(function (img) {
      if (img._campaignDragDisabled) return;
      img._campaignDragDisabled = true;
      img.setAttribute('draggable', 'false');
      img.addEventListener('dragstart', function (e) {
        e.preventDefault();
      });
    });
  };

  CampaignPdpGallery.prototype.refreshOwlHeight = function () {
    if (!this.$carousel || !this.$carousel.data('owl.carousel')) return;
    var $carousel = this.$carousel;
    $carousel.trigger('refresh.owl.carousel');
    // refresh.owl.carousel adds .owl-refresh (visibility:hidden on every item)
    // and is supposed to remove it synchronously when done. In some layouts the
    // class can be left on, hiding the main image until the next resize. Strip it
    // ourselves on the next frame so a slide can never get stuck invisible.
    window.requestAnimationFrame(function () {
      $carousel.removeClass('owl-refresh');
    });
  };

  CampaignPdpGallery.prototype.bindMainImageLoad = function () {
    var self = this;
    var images = this.root.querySelectorAll(
      '.dx-main-image-frame .dx-main-image, .dx-main-image-frame img.dx-main-image'
    );

    images.forEach(function (img) {
      if (img._campaignGalleryLoadBound) return;
      img._campaignGalleryLoadBound = true;

      var handler = function () {
        window.requestAnimationFrame(function () {
          self.refreshOwlHeight();
        });
      };

      if (img.complete) {
        handler();
      } else {
        img.addEventListener('load', handler, { once: true });
        img.addEventListener('error', handler, { once: true });
      }
    });
  };

  CampaignPdpGallery.prototype.getThumbLinks = function (nav) {
    return Array.prototype.slice.call(nav.querySelectorAll('.thumbnail-link'));
  };

  CampaignPdpGallery.prototype.getVisibleThumbLinks = function (nav) {
    return this.getThumbLinks(nav).filter(function (thumb) {
      return thumb.offsetWidth > 0;
    });
  };

  CampaignPdpGallery.prototype.getThumbStripMaxScroll = function (nav) {
    return Math.max(0, nav.scrollWidth - nav.clientWidth);
  };

  CampaignPdpGallery.prototype.getThumbScrollLeft = function (nav, thumb) {
    var navRect = nav.getBoundingClientRect();
    var thumbRect = thumb.getBoundingClientRect();
    return thumbRect.left - navRect.left + nav.scrollLeft;
  };

  CampaignPdpGallery.prototype.prefersReducedMotion = function () {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  };

  CampaignPdpGallery.prototype.getThumbStripScrollTarget = function (nav, direction) {
    var visibleThumbs = this.getVisibleThumbLinks(nav);
    var maxScroll = this.getThumbStripMaxScroll(nav);
    var scrollLeft = nav.scrollLeft;
    var eps = 2;
    var target = scrollLeft;

    if (direction > 0) {
      for (var i = 0; i < visibleThumbs.length; i++) {
        var nextLeft = this.getThumbScrollLeft(nav, visibleThumbs[i]);
        if (nextLeft > scrollLeft + eps) {
          target = nextLeft;
          break;
        }
      }
      if (target === scrollLeft) target = maxScroll;
    } else {
      for (var j = visibleThumbs.length - 1; j >= 0; j--) {
        var prevLeft = this.getThumbScrollLeft(nav, visibleThumbs[j]);
        if (prevLeft < scrollLeft - eps) {
          target = prevLeft;
          break;
        }
      }
      if (target === scrollLeft) target = 0;
    }

    return Math.round(Math.max(0, Math.min(maxScroll, target)));
  };

  CampaignPdpGallery.prototype.releaseThumbStripScroll = function (nav) {
    nav._campaignThumbScrolling = false;
    if (nav._campaignThumbScrollFallback) {
      window.clearTimeout(nav._campaignThumbScrollFallback);
      nav._campaignThumbScrollFallback = null;
    }
    this.syncThumbArrows();
  };

  CampaignPdpGallery.prototype.animateThumbStripScroll = function (nav, targetLeft) {
    var self = this;
    var maxScroll = this.getThumbStripMaxScroll(nav);
    var left = Math.round(Math.max(0, Math.min(maxScroll, targetLeft)));

    if (Math.abs(nav.scrollLeft - left) < 2) {
      this.releaseThumbStripScroll(nav);
      return;
    }

    nav._campaignThumbScrolling = true;
    nav.scrollTo({
      left: left,
      behavior: this.prefersReducedMotion() ? 'auto' : 'smooth',
    });

    if (nav._campaignThumbScrollFallback) {
      window.clearTimeout(nav._campaignThumbScrollFallback);
    }

    var onComplete = function () {
      if (nav._campaignThumbScrollDone) return;
      nav._campaignThumbScrollDone = true;
      if (nav._campaignThumbScrollFallback) {
        window.clearTimeout(nav._campaignThumbScrollFallback);
        nav._campaignThumbScrollFallback = null;
      }
      if (nav._campaignThumbScrollEndHandler) {
        nav.removeEventListener('scrollend', nav._campaignThumbScrollEndHandler);
        nav._campaignThumbScrollEndHandler = null;
      }
      self.releaseThumbStripScroll(nav);
    };

    nav._campaignThumbScrollDone = false;

    if (!this.prefersReducedMotion() && 'onscrollend' in nav) {
      if (nav._campaignThumbScrollEndHandler) {
        nav.removeEventListener('scrollend', nav._campaignThumbScrollEndHandler);
      }
      nav._campaignThumbScrollEndHandler = onComplete;
      nav.addEventListener('scrollend', nav._campaignThumbScrollEndHandler, { once: true });
    }

    nav._campaignThumbScrollFallback = window.setTimeout(onComplete, 420);
  };

  CampaignPdpGallery.prototype.queueThumbArrowSync = function () {
    var self = this;
    if (this._thumbArrowSyncRaf) return;
    this._thumbArrowSyncRaf = window.requestAnimationFrame(function () {
      self._thumbArrowSyncRaf = 0;
      self.syncThumbArrows();
    });
  };

  CampaignPdpGallery.prototype.stepMainCarousel = function (direction) {
    var core = this.getOwlCore();
    if (!core) return;

    var count = core.items().length;
    if (count <= 1) return;

    var rel = core.relative(core.current());
    var next = Math.max(0, Math.min(count - 1, rel + direction));
    if (next === rel) return;

    var self = this;
    this.navigating = true;
    core.to(next, 250, true);
    window.setTimeout(function () {
      self.navigating = false;
      self.lastRelativeIndex = self.getRelativeIndex();
      self.onSlideChanged();
    }, 300);
  };

  CampaignPdpGallery.prototype.scrollThumbStrip = function (nav, direction) {
    if (nav._campaignThumbScrolling) return;

    var visibleThumbs = this.getVisibleThumbLinks(nav);
    if (visibleThumbs.length === 0) return;

    var maxScroll = this.getThumbStripMaxScroll(nav);
    var eps = 2;
    var target;

    if (maxScroll <= eps) {
      this.stepMainCarousel(direction);
      return;
    }

    if (this.isMobile()) {
      var step = nav.clientWidth;
      target = nav.scrollLeft + direction * step;
      if (direction < 0 && target <= step * 0.35) target = 0;
      if (direction > 0 && target >= maxScroll - step * 0.35) target = maxScroll;
      target = Math.max(0, Math.min(maxScroll, target));
    } else {
      target = this.getThumbStripScrollTarget(nav, direction);
    }

    nav._campaignThumbScrolling = true;
    this.animateThumbStripScroll(nav, target);
  };

  CampaignPdpGallery.prototype.syncThumbArrows = function () {
    var self = this;
    var core = this.getOwlCore();
    var slideCount = core ? core.items().length : 0;
    var canStepCarousel = slideCount > 1;

    this.root.querySelectorAll('.product-thumbnails-nav-row').forEach(function (row) {
      var nav = row.querySelector('.product-thumbnails-nav');
      var btnPrev = row.querySelector('.product-thumbnails-nav__btn--prev');
      var btnNext = row.querySelector('.product-thumbnails-nav__btn--next');
      if (!nav || !btnPrev || !btnNext) return;

      var eps = 2;
      var maxScroll = self.getThumbStripMaxScroll(nav);
      var left = nav.scrollLeft;
      var stripOverflow = maxScroll > eps;
      var canLeft = stripOverflow ? left > eps : canStepCarousel && self.getRelativeIndex() > 0;
      var canRight = stripOverflow
        ? left < maxScroll - eps
        : canStepCarousel && self.getRelativeIndex() < slideCount - 1;

      btnPrev.classList.toggle('product-thumbnails-nav__btn--active', canLeft);
      btnNext.classList.toggle('product-thumbnails-nav__btn--active', canRight);
    });
  };

  CampaignPdpGallery.prototype.scheduleThumbArrowSync = function () {
    var self = this;
    [0, 100, 300, 600, 1200].forEach(function (delay) {
      window.setTimeout(function () {
        self.syncThumbArrows();
      }, delay);
    });

    window.addEventListener(
      'load',
      function () {
        self.syncThumbArrows();
      },
      { once: true }
    );

    if (!this._thumbArrowResizeBound) {
      this._thumbArrowResizeBound = true;
      window.addEventListener(
        'resize',
        function () {
          window.requestAnimationFrame(function () {
            self.syncThumbArrows();
          });
        },
        { passive: true }
      );
    }

    this.root.querySelectorAll('.product-thumbnails-nav').forEach(function (nav) {
      if (nav._campaignThumbRo) return;
      if (typeof ResizeObserver === 'undefined') return;
      nav._campaignThumbRo = new ResizeObserver(function () {
        self.syncThumbArrows();
      });
      nav._campaignThumbRo.observe(nav);
      nav.querySelectorAll('.thumbnail-image').forEach(function (img) {
        if (img.complete) return;
        img.addEventListener(
          'load',
          function () {
            self.syncThumbArrows();
          },
          { once: true }
        );
      });
    });
  };

  CampaignPdpGallery.prototype.bindThumbArrows = function () {
    var self = this;

    this.root.querySelectorAll('.product-thumbnails-nav-row').forEach(function (row) {
      var nav = row.querySelector('.product-thumbnails-nav');
      var btnPrev = row.querySelector('.product-thumbnails-nav__btn--prev');
      var btnNext = row.querySelector('.product-thumbnails-nav__btn--next');
      if (!nav || !btnPrev || !btnNext) return;

      btnPrev.addEventListener('click', function () {
        self.scrollThumbStrip(nav, -1);
      });
      btnNext.addEventListener('click', function () {
        self.scrollThumbStrip(nav, 1);
      });
      nav.addEventListener(
        'scroll',
        function () {
          self.queueThumbArrowSync();
        },
        { passive: true }
      );
    });

    this.scheduleThumbArrowSync();
  };

  CampaignPdpGallery.prototype.bindThumbnails = function () {
    var self = this;

    this.root.querySelectorAll('.thumbnail-link').forEach(function (thumb) {
      thumb.addEventListener('click', function (e) {
        e.preventDefault();
        var slideRef = thumb.getAttribute('data-dx-thumb');
        if (!slideRef) return;
        self.goTo(slideRef);
        window.setTimeout(function () {
          self.updateActiveThumbnail(thumb.getAttribute('data-media-id'));
        }, 320);
      });
    });
  };

  CampaignPdpGallery.prototype.bindBreakpointChange = function () {
    var self = this;

    // Re-init Owl whenever we cross the mobile (749px) or desktop (990px)
    // boundary: slide layout and CSS aspect/thumb rules differ per breakpoint,
    // and Owl caches stage widths that must be rebuilt. Without this the gallery
    // stays stuck in whichever layout it first loaded with until a page refresh.
    // Debounced so a drag-resize that crosses both boundaries reinits once.
    var reinitHandler = function () {
      if (self._reinitTimer) window.clearTimeout(self._reinitTimer);
      self._reinitTimer = window.setTimeout(function () {
        self._reinitTimer = null;
        self.reinit();
      }, 120);
    };

    var mobileMq = window.matchMedia(MOBILE_MQ);
    [mobileMq, this.desktopSlideMq].forEach(function (mq) {
      if (mq.addEventListener) {
        mq.addEventListener('change', reinitHandler);
      } else if (mq.addListener) {
        mq.addListener(reinitHandler);
      }
    });

    // Owl re-measures its own stage on window resize, so we only keep the
    // thumbnail-strip arrows in sync here (debounced). We deliberately do NOT
    // trigger refresh.owl.carousel on resize: that adds the .owl-refresh class
    // (visibility:hidden on every item) and mobile browsers fire resize
    // constantly while the address bar collapses, which left the main image
    // hidden. Breakpoint crossings are handled by reinit() above.
    if (!this._resizeRefreshBound) {
      this._resizeRefreshBound = true;
      window.addEventListener(
        'resize',
        function () {
          if (self._resizeRefreshTimer) {
            window.clearTimeout(self._resizeRefreshTimer);
          }
          self._resizeRefreshTimer = window.setTimeout(function () {
            self._resizeRefreshTimer = null;
            self.syncThumbArrows();
          }, 150);
        },
        { passive: true }
      );
    }
  };

  CampaignPdpGallery.prototype.reinit = function () {
    var self = this;
    this.initOwl(function () {
      self.bindMainImageLoad();
      self.syncThumbArrows();
      self.updateActiveThumbnail();
    });
  };

  CampaignPdpGallery.prototype.init = function () {
    if (this.initialized) return;
    var self = this;

    this.initOwl(function () {
      self.bindThumbnails();
      self.bindThumbArrows();
      self.bindBreakpointChange();
      self.syncThumbArrows();
      self.updateActiveThumbnail();
      self.initialized = true;
    });

    // Owl can compute slide widths before the section's grid column / sticky
    // media card has its final width, leaving the main image blank until a
    // resize. Re-measure once everything (images, fonts, layout) has settled.
    var settle = function () {
      self.refreshOwlHeight();
      self.syncThumbArrows();
    };
    if (document.readyState === 'complete') {
      window.requestAnimationFrame(settle);
    } else {
      window.addEventListener('load', settle, { once: true });
    }
  };

  function boot() {
    var roots = document.querySelectorAll('.pdp-gallery--campaign');
    if (roots.length === 0) {
      window.setTimeout(boot, 100);
      return;
    }

    roots.forEach(function (root) {
      if (root._campaignPdpGallery) return;
      var gallery = new CampaignPdpGallery(root);
      root._campaignPdpGallery = gallery;
      gallery.init();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
